import { useEffect, useState } from "react";

const getDeviceModeFlg = () => {
  if (typeof window === "undefined") {
    return false;
  }

  return window.innerHeight > window.innerWidth;
};

const useDeviceModeFlg = () => {
  const [deviceModeFlg, setDeviceModeFlg] = useState(getDeviceModeFlg);

  useEffect(() => {
    const handleResize = () => {
      setDeviceModeFlg(getDeviceModeFlg());
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return deviceModeFlg;
};

export default useDeviceModeFlg;
